module.exports = __webpack_public_path__ + "d3738195f4fe8118a927ce36af9e855a.fbx";